import { mode } from "@chakra-ui/theme-tools";
export const globalStyles = {
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
  colors: {
    brand: {
      100: "#e8f5ee",
      200: "#b8e0cb",
      300: "#7cc9a0",
      400: "#5fc48a",
      500: "#48b47b",
      600: "#3da36d",
      700: "#1e3a5f",
      800: "#0f2744",
      900: "#0a1a2e",
    },
    brandScheme: {
      100: "#e8f5ee",
      200: "#7cc9a0",
      300: "#48b47b",
      400: "#48b47b",
      500: "#48b47b",
      600: "#3da36d",
      700: "#1e3a5f",
      800: "#0f2744",
      900: "#0a1a2e",
    },
    brandTabs: {
      100: "#e8f5ee",
      200: "#48b47b",
      300: "#48b47b",
      400: "#3da36d",
      500: "#48b47b",
      600: "#3da36d",
      700: "#1e3a5f",
      800: "#0f2744",
      900: "#0a1a2e",
    },
    secondaryGray: {
      100: "#e8edf2",
      200: "#dce8e2",
      300: "#eef4f1",
      400: "#e4ece8",
      500: "#7a8ba8",
      600: "#6b7c96",
      700: "#4a5f78",
      800: "#3d5168",
      900: "#1e3a5f",
    },
    red: {
      100: "#FEEFEE",
      500: "#EE5D50",
      600: "#E31A1A",
    },
    blue: {
      50: "#EFF4FB",
      500: "#3965FF",
    },
    orange: {
      100: "#FFF6DA",
      500: "#FFB547",
    },
    green: {
      100: "#e8f5ee",
      500: "#48b47b",
    },
    navy: {
      50: "#e8eef4",
      100: "#c5d4e4",
      200: "#8fa8c4",
      300: "#5a7fa3",
      400: "#3d6285",
      500: "#1e3a5f",
      600: "#18304f",
      700: "#122640",
      800: "#0f2744",
      900: "#0a1a2e",
    },
    gray: {
      100: "#FAFCFE",
    },
  },
  semanticTokens: {
    colors: {
      "app.bg": {
        default: "secondaryGray.300",
        _dark: "navy.900",
      },
      "app.surface": {
        default: "white",
        _dark: "navy.800",
      },
      "app.text": {
        default: "secondaryGray.900",
        _dark: "white",
      },
      "app.muted": {
        default: "secondaryGray.600",
        _dark: "secondaryGray.400",
      },
      "app.border": {
        default: "gray.200",
        _dark: "whiteAlpha.200",
      },
    },
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: "hidden",
        bg: mode("secondaryGray.300", "navy.900")(props),
        color: mode("secondaryGray.900", "whiteAlpha.900")(props),
        fontFamily: '"Inter", "DM Sans", system-ui, -apple-system, sans-serif',
        letterSpacing: "-0.5px",
      },
      html: {
        fontFamily: '"Inter", "DM Sans", system-ui, -apple-system, sans-serif',
      },
      ".chakra-input, .chakra-textarea, .chakra-select": {
        color: mode("gray.800", "white")(props),
      },
      "input, textarea, select": {
        color: mode("gray.800", "white")(props),
        colorScheme: mode("light", "dark")(props),
      },
      "input[type='date'], input[type='time'], input[type='datetime-local']": {
        colorScheme: mode("light", "dark")(props),
      },
      "option": {
        bg: mode("white", "navy.800")(props),
        color: mode("gray.800", "white")(props),
      },
      "::selection": {
        bg: mode("brand.200", "brand.600")(props),
        color: mode("navy.900", "white")(props),
      },
    }),
  },
};
